export type SizeType =
  | 'sm-400'
  | 'sm-500'
  | 'sm-600'
  | 'sm-700'
  | 'md-400'
  | 'md-500'
  | 'md-600'
  | 'md-700'
  | 'lg-400'
  | 'lg-500'
  | 'lg-600'
  | 'lg-700'
  | 'xl-400'
  | 'xl-500'
  | 'xl-600'
  | 'xl-700'
  | '2xl-400'
  | '2xl-500'
  | '2xl-600'
  | '2xl-700';

export const BUTTON_SIZE: Record<SizeType, string> = {
  'sm-400': 'py-2 text-captionRegular',
  'sm-500': 'py-2 text-captionMedium',
  'sm-600': 'py-2 text-captionSemiBold',
  'sm-700': 'py-2 text-captionBold',
  'md-400': 'py-3 text-body2Regular',
  'md-500': 'py-3 text-body2Medium',
  'md-600': 'py-3 text-body2SemiBold',
  'md-700': 'py-3 text-body2Bold',
  'lg-400': 'py-4 text-headline1Regular',
  'lg-500': 'py-4 text-headline1Medium',
  'lg-600': 'py-4 text-headline1SemiBold',
  'lg-700': 'py-4 text-headline1Bold',
  'xl-400': 'py-6 text-title1Regular',
  'xl-500': 'py-6 text-title1Medium',
  'xl-600': 'py-6 text-title1SemiBold',
  'xl-700': 'py-6 text-title1Bold',
  '2xl-400': 'py-7 text-display2Regular',
  '2xl-500': 'py-7 text-display2Medium',
  '2xl-600': 'py-7 text-display2SemiBold',
  '2xl-700': 'py-7 text-display2Bold',
};
